<template>
  <div class="subscription-forms">
    <logo />

    <div class="summary">
      <img class="ellipse" :src="mediaBaseUrl + 'ellipse.png'" alt="">
      <img class="ellipse" :src="mediaBaseUrl + 'ellipse.png'" alt="">

      <div class="summary__part">
        <div class="progress-bar-track">
          <div class="progress-bar" :style="{width: progress + '%'}"></div>
        </div>

        <h3>Order Summary</h3>
        <div class="summary__record" v-for="(record, i) in records" :key="i">
          <div class="record__title">
            <img v-if="record.icon" :src="mediaBaseUrl + record.icon" alt="" />
            <span class="record__name">{{record.name}}</span>
          </div>
          <span class="record__price" :class="{price_offer: record.offer}">
            {{typeof record.price === 'string' ? '' : '$'}}{{record.price}}
            <span v-if="record.trial">{{record.trial}}</span>
          </span>
        </div>
      </div>

      <div class="line"></div>

      <div class="summary__part summary__total">
        <div class="summary__record">
          <div class="record__title">
            <span class="record__name">Total</span>
          </div>
          <span class="record__price">$0</span>
        </div>
      </div>
    </div>

    <form class="subcription-form" @submit.prevent="startPayment()">
      <img class="ellipse" :src="mediaBaseUrl + 'ellipse.png'" alt="">
      <img class="ellipse" :src="mediaBaseUrl + 'ellipse.png'" alt="">

      <label>
        <span>First Name</span>
        <input v-model="userInfo.first_name" :disabled="loading" required type="text">
      </label>
      <label>
        <span>Last Name</span>
        <input v-model="userInfo.last_name" :disabled="loading" required type="text">
      </label>
      <label>
        <span>E-mail</span>
        <input v-model="userInfo.email" :disabled="loading" required type="email">
      </label>

      <custom-button>Start my offer</custom-button>
    </form>
  </div>
</template>

<script>
import { EventBus } from '../../../EventBus';
export default {
  name: "SubscriptionForms",
  inject: ["mediaBaseUrl"],

  data() {
    return {
      loading: false,
      userInfo: {
        first_name: '',
        last_name: '',
        email: '',
      },
      errors: null,
      records: [
        {
          icon: "product-icon.png",
          name: "Pulse Core Fitness Premium",
          price: 29.99,
          offer: true,
        },
        {
          icon: "product-icon.png",
          name: "DarkBook - Pulse Core Fitness Expert",
          price: "$0.00",
          trial: "first 3 days"
        },
      ],
      currentProgress: 1,
      allSteps: 3,
    };
  },
  methods: {
    startPayment() {
      if (this.loading) {
        return
      }
      this.loading = true
      EventBus.$emit('set-user-info', this.userInfo)
      this.tracker.report('click_try_for_free')
    },
    userInfoSaved(userInfo) {
      this.loading = false
      this.updateUserInfo(userInfo)
      this.$emit('changeModal', 'payment')
    },
    updateUserInfo(userInfo) {
      if (!userInfo) {
        return false
      }
      ['first_name', 'last_name', 'email'].forEach((key, i) => {
        if (userInfo[key]) {
          this.userInfo[key] = userInfo[key]
        }
      })
      return true
    },
  },
  mounted() {
    EventBus.$emit('get-user-info')
  },
  created() {
    EventBus.$on('user-info', this.updateUserInfo)
    EventBus.$on('user-info-saved', this.userInfoSaved)
  },
  destroyed() {
    EventBus.$off('user-info', this.updateUserInfo)
    EventBus.$off('user-info-saved', this.userInfoSaved)
  },
  computed: {
    progress() {
      return Math.floor((this.currentProgress / this.allSteps) * 100)
    },
    tracker() {
      return this.$root.$children[0].$refs.tracker
    },
  },
}
</script>

<style lang="sass">
@import '../../../sass/variables'

.subscription-forms
  display: flex
  flex-direction: column
  gap: 24px
  max-width: 343px
  width: 100%
  position: relative
  padding: 0
  margin: 0 auto 64px
  @media screen and (min-width: $lg)
    margin-bottom: 0
    h2
      display: none
  .ellipse
    width: 300px
    left: -100px
    top: -100px
    &:first-child
      left: unset
      right: -100px
      top: 45%
  .progress-bar-track
    width: 100%
    position: relative
    height: 32px
    border-radius: 12px
    background: rgba(43, 43, 43, 1)
    overflow: hidden
    .progress-bar
      left: 0
      position: absolute
      height: 100%
      border-radius: 12px
      background: rgba(254, 0, 0, 1)
  h3
    font-weight: 700
    font-size: 1.125rem
    line-height: 1.125rem
    text-align: left
  form
    box-sizing: border-box
    max-width: 100%
    padding: 32px 22px
    display: flex
    flex-direction: column
    gap: 20px
    position: relative
    .button
      width: 100%
    label
      display: flex
      flex-direction: column
      gap: 8px
      span
        font-weight: 700
        font-size: 1rem
        line-height: 1rem
        text-align: left
    input
      all: unset
      border-radius: 12px
      border: 1px solid rgba(219, 219, 219, 1)
      font-size: 1.2rem
      background: none
      outline: none
      box-shadow: none
      color: #ffffff
      padding: 15px 10px
      text-align: left
  .summary__part
    display: flex
    flex-direction: column
    gap: 16px
    padding: 20px 22px 20px 21px
  .summary__record
    display: flex
    justify-content: space-between
    gap: 3px
  .record__title
    display: flex
    gap: 12px
    text-align: left
    max-width: 70%
    img
      height: fit-content
  .record__price
    display: flex
    flex-direction: column
    align-items: flex-end
    opacity: .8
    text-align: right
    &.price_offer
      text-decoration: line-through
    span
      font-size: 0.875rem
      line-height: 1.25rem
      font-weight: 300
      font-style: italic
  .summary__total
    span
      font-weight: 700
      font-size: 1.125rem
    .record__price
      opacity: 1
  .line
    background: rgba(255, 255, 255, 0.3)
    height: 1px
    width: 100%
  > *:not(h2)
    width: 100%
    border-radius: 24px
    background: rgba(255, 255, 255, 0.05)
    position: relative
    overflow: hidden
</style>
